import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HotspotCreatorService} from '../../../service/http/hotspot-creator.service';

@Component({
  selector: 'app-rename-hotspot',
  templateUrl: './rename-hotspot.component.html',
  styleUrls: ['./rename-hotspot.component.css']
})
export class RenameHotspotComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<RenameHotspotComponent>,
              private hotspotCreatorService: HotspotCreatorService) { }

  packageId: number;
  hotspotId: number;
  hotspotTitle: string;

  hotspotTitleFormControl = new FormControl('', [
    Validators.required
  ]);

  public hotspotFormGroup = new FormGroup({
    hotspotTitle: this.hotspotTitleFormControl});

  ngOnInit() {
    this.packageId = this.data.packageId;
    this.hotspotId = this.data.hotspotId;
    this.hotspotTitle = this.data.hotspotTitle;
    this.hotspotTitleFormControl.setValue(this.data.hotspotTitle);
  }

  renameHotspot() {

    if(this.hotspotFormGroup.valid) {
      this.hotspotCreatorService.renameHotspotForPackage(this.packageId, this.hotspotId, {'title': this.hotspotTitleFormControl.value})
        .subscribe( (response) =>{
          this.dialogRef.close({newTitleSaved: true});
        }
      );
    }
  }
}
